import { render, staticRenderFns } from "./archivalrate.vue?vue&type=template&id=0f2e817d&scoped=true&"
import script from "./archivalrate.vue?vue&type=script&lang=js&"
export * from "./archivalrate.vue?vue&type=script&lang=js&"
import style0 from "./archivalrate.vue?vue&type=style&index=0&id=0f2e817d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2e817d",
  null
  
)

export default component.exports